export default __webpack_public_path__ + "static/media/img_2.1c86cd3f.JPG";